var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-popup-base", {
    attrs: {
      resources: Object.assign(
        {},
        { deleteButtonText: _vm.resource("Button_Remove") },
        _vm.resources
      ),
      invalid: _vm.$v.$invalid || _vm.invalid
    },
    on: {
      delete: function($event) {
        _vm.showDeletePrompt = true
      },
      save: function($event) {
        return _vm.$emit("save")
      },
      hide: function($event) {
        return _vm.$emit("hidden")
      },
      "display-errors": function($event) {
        return _vm.onDisplayErrors()
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function() {
            return [
              _c("div", [
                _c("div", [
                  _c("h3", [_vm._v(_vm._s(_vm.resources.brickTitle))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.displayActionableReportNavigation
                      ? _c("navigate-to-actionable-report-link", {
                          staticClass: "btn btn-outline-secondary btn-xs mr-3",
                          attrs: {
                            "journey-id": _vm.journey.id,
                            "highlighted-brick-id": _vm.brick.id,
                            disabled: _vm.isNew
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("copy-id-button", { attrs: { id: _vm.brick.id } })
                  ],
                  1
                )
              ])
            ]
          },
          proxy: true
        },
        {
          key: "body",
          fn: function() {
            return [
              _c("settings-property", {
                attrs: {
                  icon: "far fa-edit",
                  label: _vm.resource(
                    "JourneyComposer_BrickSettingsBase_Name_DisplayName"
                  )
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function(ref) {
                      var id = ref.id
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nameModel,
                              expression: "nameModel"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: id,
                            name: "name",
                            type: "text",
                            disabled: !_vm.canWrite
                          },
                          domProps: { value: _vm.nameModel },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nameModel = $event.target.value
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "errors",
                    fn: function() {
                      return [
                        _vm.$v.nameModel.$dirty && _vm.$v.nameModel.$invalid
                          ? _c("required-error-message", {
                              attrs: {
                                "field-name": _vm.resource(
                                  "JourneyComposer_BrickSettingsBase_Name_DisplayName"
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _vm.displayNewComment
                ? _c("settings-property", {
                    attrs: {
                      label: _vm.resource(
                        "JourneyComposer_BrickSettingsBase_Comment_Label"
                      )
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function(ref) {
                            var id = ref.id
                            return [
                              _c("new-comment", {
                                attrs: { "brick-id": _vm.commentId, id: id }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1486127086
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showDeletePrompt
                ? _c("delete-brick-prompt", {
                    attrs: {
                      title:
                        _vm.resources.deletePromptTitle ||
                        _vm.resource(
                          "JourneyBuilder_GenericSettings_Delete_Title"
                        ),
                      body:
                        _vm.resources.deletePromptBody ||
                        _vm.resource(
                          "JourneyBuilder_GenericSettings_Delete_Body"
                        ),
                      "brick-id": _vm.brick.id
                    },
                    on: {
                      yes: function($event) {
                        return _vm.$emit("delete")
                      },
                      hidden: function($event) {
                        _vm.showDeletePrompt = false
                      }
                    }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }